<template>
  <div class="ftp-settings-view">
    <v-container>
      <v-row>
        <v-col cols="12">
          <h1>Configuración FTP</h1>
          <p>Gestión de configuraciones FTP del sistema</p>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="ftpSettingsList"
            :loading="loading"
            class="elevation-1"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Lista de Configuraciones FTP</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="refreshData">
                  <v-icon left>mdi-refresh</v-icon>
                  Actualizar
                </v-btn>
                <v-btn color="success" class="ml-2" @click="addItem">
                  <v-icon left>mdi-plus</v-icon>
                  Agregar Configuración FTP
                </v-btn>
              </v-toolbar>
            </template>
            <template v-slot:item.host="{ item }">
              <v-chip color="blue" variant="outlined" small>
                {{ item.host }}
              </v-chip>
            </template>
            <template v-slot:item.port="{ item }">
              <v-chip color="green" variant="outlined" small>
                {{ item.port }}
              </v-chip>
            </template>
            <template v-slot:item.mode="{ item }">
              <v-chip color="purple" variant="outlined" small>
                {{ item.mode }}
              </v-chip>
            </template>
            <template v-slot:item.username="{ item }">
              <span class="font-weight-medium">{{ item.username }}</span>
            </template>
            <template v-slot:item.password="{ item }">
              <span class="font-weight-medium">{{ maskPassword(item.password) }}</span>
            </template>
            <template v-slot:item.filePath="{ item }">
              <span class="font-weight-medium">{{ item.filePath || 'No definida' }}</span>
            </template>
            <template v-slot:item.filePattern="{ item }">
              <v-chip color="orange" variant="outlined" small>
                {{ item.filePattern }}
              </v-chip>
            </template>
            <template v-slot:item.secure="{ item }">
              <v-icon 
                :color="item.secure ? 'success' : 'error'" 
                small
              >
                {{ item.secure ? 'mdi-shield-check' : 'mdi-shield-off' }}
              </v-icon>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="editItem(item)">
                mdi-pencil
              </v-icon>
              <v-icon small @click="deleteItem(item)">
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, computed } from 'vue'
import { useFtpSettingsStore } from './store'
import { FtpSettings } from './models/ftpSettings'

const ftpSettingsStore = useFtpSettingsStore()
const loading = ref(false)

const headers = [
  { title: 'ID', key: 'id' },
  { title: 'Servidor', key: 'host' },
  { title: 'Puerto', key: 'port' },
  { title: 'Usuario', key: 'username' },
  { title: 'Contraseña', key: 'password' },
  { title: 'Ruta', key: 'filePath' },
  { title: 'Patrón', key: 'filePattern' },
  { title: 'Modo', key: 'mode' },
  { title: 'Seguro', key: 'secure' },
  { title: 'Acciones', key: 'actions', sortable: false },
]

const ftpSettingsList = computed(() => ftpSettingsStore.ftpSettings)

const maskPassword = (password: string) => {
  // Función para enmascarar la contraseña mostrando solo asteriscos
  if (!password) return 'Sin contraseña'
  return '*'.repeat(password.length)
}

const refreshData = async () => {
  loading.value = true
  try {
    await ftpSettingsStore.getFtpSettings()
  } finally {
    loading.value = false
  }
}

const addItem = () => {
  // Implementar lógica para agregar configuración FTP
  console.log('Add new FTP settings')
}

const editItem = (item: FtpSettings) => {
  // Implementar lógica de edición
  console.log('Edit item:', item)
}

const deleteItem = (item: FtpSettings) => {
  // Implementar lógica de eliminación
  console.log('Delete item:', item)
}

onMounted(() => {
  refreshData()
})
</script>

<style scoped>
.ftp-settings-view {
  height: 100%;
}
</style>
